import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { FiatWalletAccountState } from '#src/__generated__/globalTypes.ts';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { CreateFiatWallet } from '#src/components/fiatWallet/CreateFiatWallet/index.tsx';
import { OffRampStepLayout } from '#src/components/offRamp/OffRampKycOnboarding/OffRampStepLayout/index.tsx';

type Props = {
  onWalletChange: () => void;
};

export const MangopayKycRequiredStep = ({ onWalletChange }: Props) => {
  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
    onWalletChange();
  };

  return (
    <OffRampStepLayout
      title={<FormattedMessage defaultMessage="Verify your identity first" />}
      description={
        <FormattedMessage defaultMessage="Before you can cash out, you need to finish setting up your Sorare cash wallet and verify your identity." />
      }
    >
      <Button size="medium" fullWidth onClick={() => setOpen(true)}>
        <FormattedMessage defaultMessage="Set up my cash wallet" />
      </Button>
      {open ? (
        <CreateFiatWallet
          statusTarget={FiatWalletAccountState.VALIDATED_OWNER}
          canDismissAfterActivation
          onClose={close}
          onDismissActivationSuccess={close}
        />
      ) : null}
    </OffRampStepLayout>
  );
};
